import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Article Types',
  basePath: '/articletypes',
  rowKey: 'pid',
  reorderable: true,
  columns: [
    { key: 'section_title', label: 'Section' },
    { key: 'superior_name', label: 'Superior' },
    { key: 'articletype_name', label: 'Article Type' },
    { key: 'permanent', label: 'Permanent',
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'display_author', label: 'Display Author',
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'advertising', label: 'Advertising',
      render: (v) => v == 1 ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'articletype_id', label: 'Article Section', type: 'async-select',
      optionsUrl: '/article-sections/options' },
    { key: 'articletype_superior', label: 'Article Type Superior', type: 'async-select',
      optionsUrl: '/article-superiors/options' },
    { key: 'articletype_name', label: 'Article Type', type: 'text',
      fieldInfo: 'Title of article section for the country' },
    { key: 'permanent', label: 'Permanent', type: 'yesno', defaultValue: '0' },
    { key: 'display_author', label: 'Display Author', type: 'yesno', defaultValue: '0' },
    { key: 'advertising', label: 'Advertising', type: 'yesno', defaultValue: '0' },
    { key: 'category_title', label: 'Category Title', type: 'text' },
    { key: 'category_intro', label: 'Category Intro', type: 'text' },
    { key: 'category_description', label: 'Category Description', type: 'rich-text' },
  ],
  rowActions: [{ key: 'edit', label: 'Edit' }],
});
